import React from "react";
import { Anchor, PageWidth } from "../components";
import { useSettings } from "../hooks";
import { useNode } from "../node";
import { gql, useQuery } from "@apollo/client";

export function Footer() {
  const {
    title,
    nationalHeadquarters,
    phoneNumber = "",
    emailAddress,
  } = useSettings();
  const { node: about } = useNode({ uri: "/about/" });
  const { data } = useQuery(FooterMenu);
  const menu = data?.faqs?.nodes || [];
  const links = data?.links?.nodes || [];

  return (
    <footer id="footer" className="bg-mid-gray moon-gray f7">
      <div>
        <PageWidth className="overflow-hidden">
          <div className="flex-l pv4 nl3-l nr3-l">
            <FooterColumn>
              <Title>Contact Info</Title>

              <div id="contact-national-headquarters">
                {nationalHeadquarters}
              </div>

              <div className={!phoneNumber ? "dn" : null}>
                <a
                  href={`tel:+1${phoneNumber.replace(/\D+/g, "")}`}
                  rel="noopen nofollow"
                  className="no-underline color-inherit phone-number"
                >
                  {phoneNumber}
                </a>
              </div>

              <div className={!emailAddress ? "dn" : null}>
                <a
                  href={`mailto:${emailAddress}`}
                  rel="noopen nofollow"
                  className="no-underline color-inherit email-address"
                >
                  {emailAddress}
                </a>
              </div>
            </FooterColumn>
            <FooterColumn>
              {about.excerpt && (
                <>
                  <Title>About Us</Title>

                  <div dangerouslySetInnerHTML={{ __html: about.excerpt }} />
                </>
              )}
            </FooterColumn>
            <FooterColumn>
              <Title>FAQs</Title>

              <nav className="lh-copy">
                {menu.map((node) => (
                  <MenuLink key={node.id} {...node} />
                ))}
              </nav>
            </FooterColumn>
            <FooterColumn>
              <Title>Helpful Links</Title>

              <nav className="lh-copy">
                {links.map((node) => (
                  <MenuLink key={node.id} {...node} />
                ))}
              </nav>
            </FooterColumn>
          </div>
        </PageWidth>
      </div>
      <div className="pv2">
        <PageWidth>
          <div className="flex-l items-center-l">
            <div>
              Copyright {new Date().getFullYear()}{" "}
              {title ? ` - ${title}` : "..."}
              <span> | All rights reserved</span>
            </div>

            <div className="ml-auto-l"></div>
          </div>
        </PageWidth>
      </div>
    </footer>
  );
}

function MenuLink({ url, label }) {
  const props = { className: "color-inherit no-underline db" };

  props.href = url;

  return <Anchor {...props}>{label}</Anchor>;
}

function FooterColumn({ children, className = "" }) {
  return <div className={`w-100 w-25-l ph3-l ${className}`}>{children}</div>;
}

function Title({ children }) {
  return <div className="mb3 white f6 ttu">{children}</div>;
}

const FooterMenu = gql`
  query FooterMenu {
    faqs: menuItems(where: { location: FOOTER_MENU }) {
      nodes {
        id
        url
        label
        connectedNode {
          node {
            __typename
          }
        }
      }
    }
    links: menuItems(where: { location: LINKS }) {
      nodes {
        id
        url
        label
        connectedNode {
          node {
            __typename
          }
        }
      }
    }
  }
`;

export default Footer;
